import { Pill } from "../ui/Pill";
import { t } from "../../i18n/strings";
import type { HealthResponse } from "../../api/client";
import type { Locale } from "../../templates/types";

export function ModeBadge({
  health,
  degraded,
  locale = "en",
}: {
  health: HealthResponse | null;
  degraded?: boolean;
  locale?: Locale;
}) {
  let content;
  if (degraded) {
    content = <Pill tone="warn">{t(locale, "modeBadge.demoDegraded")}</Pill>;
  } else if (!health) {
    content = <Pill tone="neutral">{t(locale, "modeBadge.checking")}</Pill>;
  } else {
    content =
      health.mode === "live" ? (
        <Pill tone="sage">{t(locale, "modeBadge.live")}</Pill>
      ) : (
        <Pill tone="clay">{t(locale, "modeBadge.demo")}</Pill>
      );
  }

  // The mode can genuinely change while the page is open (health check
  // resolves after mount; a turn can degrade to Demo mid-interview) — a
  // real live-updating status, not a duplicate of any other aria-live region.
  return (
    <div role="status" aria-live="polite" className="inline-flex">
      {content}
    </div>
  );
}
